/*
 * Copyright 2026 Sony Corporation
 */

/**
 * The two pages that carry the 3D engine, split out of the entry bundle so the
 * login and world list do not wait on it. Calling one early is a preload: the
 * import is only ever fetched once.
 */
export const loadWorldEditor = () => import('./WorldEditor');
export const loadScenePage = () => import('./ScenePage');
